import { ValidatedOrders } from '../../ImportOrders.types'
import {
  ErrorsData,
  OrdersAdapted,
  ProccessedOrders,
} from './ThirdStepVerticalHorizontal.types'

export const getSummaryData = (
  validatedOrders: ValidatedOrders | undefined,
  retailerName: string,
): OrdersAdapted => {
  const orderIdentifiers = validatedOrders?.orders.map(
    (order) => order?.orderIdentifier,
  )
  const uniqueOrderIdentifiers = Array.from(new Set(orderIdentifiers))

  const ordersForRetailer = uniqueOrderIdentifiers.map((identifier) => {
    // @ts-expect-error
    let orderName = validatedOrders!.orders.find(
      (order) => order?.orderIdentifier === identifier,
    ).skuLineItems[0]?.payload?.fields?.po_label?.stringValue
    if (!orderName) {
      orderName = identifier
    }
    return {
      orderName: orderName,
      skus: validatedOrders!.orders
        .filter((order) => order.orderIdentifier === identifier)
        .reduce((sum, order) => sum + order.skuLineItems.length, 0),
      units: validatedOrders!.orders
        .filter((order) => order.orderIdentifier === identifier)
        .reduce(
          (sum, order) =>
            (sum += order.skuLineItems.reduce(
              (quantity, sku) => quantity + sku.quantity * sku.multiplier,
              0,
            )),
          0,
        ),
      total: validatedOrders!.orders
        .filter((order) => order.orderIdentifier === identifier)
        .reduce(
          (sum, order) =>
            sum +
            order.skuLineItems.reduce(
              (quantity, sku) =>
                quantity + sku.quantity * sku.multiplier * sku.wholesalePrice,
              0,
            ),
          0,
        ),
    }
  })

  const ordersAdapted: ProccessedOrders[] = [
    {
      id: 'summaryRow' + retailerName,
      orderName: retailerName,
      skus: ordersForRetailer.reduce((sum, order) => sum + order.skus, 0),
      units: ordersForRetailer.reduce((sum, order) => sum + order.units, 0),
      total: ordersForRetailer.reduce((sum, order) => sum + order.total, 0),
      subItems: ordersForRetailer,
    },
  ]

  return {
    aggregated: {
      id: 'aggregatedData',
      orderName: 'Total',
      skus: ordersAdapted.reduce((sum, orderAd) => sum + orderAd.skus, 0),
      units: ordersAdapted.reduce((sum, orderAd) => sum + orderAd.units, 0),
      total: ordersAdapted.reduce((sum, orderAd) => sum + orderAd.total, 0),
    },
    orders: ordersAdapted,
  }
}

export const getErrorsData = (
  validatedOrders: ValidatedOrders | undefined,
): ErrorsData => {
  const orderErrors = validatedOrders?.errors || []
  const errorTypes = orderErrors.map((error) => error.type)
  const uniqueErrorTypes = Array.from(new Set(errorTypes))
  const errorSummary: Array<string> = []

  uniqueErrorTypes.map((errorType) => {
    const orderErrorsFiltered = orderErrors.filter(
      (orderError) => orderError.type === errorType,
    )
    const errorCodes = orderErrorsFiltered.map((error) => error.code)
    const uniqueErrorCodes = Array.from(new Set(errorCodes))

    uniqueErrorCodes.forEach((errorCode) => {
      const errorsNumber = orderErrors.filter(
        (error) => error.type === errorType && error.code === errorCode,
      ).length
      errorSummary.push(
        `${errorsNumber} item${errorsNumber !== 1 ? 's' : ''} with ${
          errorType ? errorType.toLowerCase().replace('_', ' ') : 'undefined'
        } ${errorCode ? errorCode.toLowerCase().replace('_', ' ') : 'error'}`,
      )
    })
  })
  return errorSummary
}

export const downloadURL = (url: string): void => {
  const link = document.createElement('a')
  link.href = url
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
